import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const samplePortfolio = [
    {
        name: 'NeuralMed AI',
        description: 'Reimagining drug discovery with AI-powered molecular design',
        initial: 'N',
        initialBg: 'bg-purple-500',
        industry: 'Healthcare AI',
        series: 'Series A',
        link: '#'
    },
    {
        name: 'SecureStack',
        description: 'Next-gen cloud security and compliance automation',
        initial: 'S',
        initialBg: 'bg-orange-500',
        industry: 'DevTools',
        series: 'Seed',
        link: '#',
        external: true
    },
    {
        name: 'DataFlow Systems',
        description: 'High-performance data infrastructure for AI workloads',
        initial: 'D',
        initialBg: 'bg-green-500',
        industry: 'Infrastructure',
        series: 'Series B',
        link: '#'
    },
    {
        name: 'AgentOS',
        description: 'Operating system for autonomous AI agents',
        initial: 'A',
        initialBg: 'bg-sky-500',
        industry: 'AI Applications',
        series: 'Series A',
        link: '#'
    },
    {
        name: 'BioSignal Labs',
        description: 'Clinical-grade AI for diagnostic imaging',
        initial: 'B',
        initialBg: 'bg-fuchsia-600',
        industry: 'Healthcare AI',
        series: 'Seed',
        link: '#'
    },
    {
        name: 'CodeVault',
        description: 'AI-powered code security and vulnerability detection',
        initial: 'C',
        initialBg: 'bg-orange-600',
        industry: 'Security',
        series: 'Series A',
        link: '#'
    },
];

const FeaturedPortfolio = () => {
    const location = useLocation();
    const isPortfolioPage = location.pathname === '/portfolio';

    return (
        <section id="portfolio" className="bg-background py-24 md:py-32">
            <div className="container mx-auto px-6">

                {/* --- UPDATED: Wrapped Header and Text in Conditional --- */}
                {/* This block will ONLY render if NOT on /portfolio */}
                {!isPortfolioPage && (
                    <>
                        <h2 className="text-4xl md:text-5xl font-bold text-center text-foreground">Portfolio</h2>
                        <p className="text-lg text-muted-foreground max-w-3xl mx-auto text-center mt-4">
                            We partner with founders from day one, investing across stages where conviction and contribution compound.
                        </p>
                    </>
                )}

                {/* Grid remains visible on both pages (or adjust as needed) */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16 max-w-7xl mx-auto">
                    {samplePortfolio.map((item, index) => (
                        <motion.div
                            key={item.name}
                            className="bg-card rounded-xl shadow-medium border border-border transition-all duration-300 hover:shadow-strong hover:border-secondary/50 group"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <Link to="/portfolio" className="block h-full text-left p-6">
                                <div className="flex items-center mb-4">
                                    <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white text-lg font-bold ${item.initialBg}`}>
                                        {item.initial}
                                    </div>
                                </div>

                                <h3 className="text-xl font-bold text-card-foreground group-hover:text-primary transition-colors mb-2">
                                    {item.name}
                                </h3>
                                <p className="text-base text-muted-foreground leading-relaxed min-h-[4.5rem]">{item.description}</p>

                                <div className="mt-4 flex flex-wrap gap-2">
                                    <span className="inline-block bg-muted text-muted-foreground text-xs font-medium px-3 py-1 rounded-full">
                                        {item.industry}
                                    </span>
                                    <span className="inline-block bg-muted text-muted-foreground text-xs font-medium px-3 py-1 rounded-full">
                                        {item.series}
                                    </span>
                                </div>
                                <div className="mt-4 h-1 bg-gradient-to-r from-blue-500 to-purple-600 w-0 group-hover:w-full transition-all duration-300 rounded-full"></div>
                            </Link>
                        </motion.div>
                    ))}
                </div>

                {/* Button also hidden on /portfolio */}
                {!isPortfolioPage && (
                    <div className="mt-16 text-center">
                        <Link
                            to="/portfolio"
                            className="inline-block font-semibold py-3 px-8 rounded-lg border-2 border-secondary text-secondary transition-all duration-300 hover:bg-secondary hover:text-white"
                        >
                            See All Portfolio Companies
                        </Link>
                    </div>
                )}
            </div>
        </section>
    );
};

export default FeaturedPortfolio;